<template>
  <v-btn
    @click.stop="showCommentAside(commentState)"
    :color="countOfComment ? 'success' : 'default'"
    small
  >
    Comments ({{ countOfComment }})
  </v-btn>
</template>

<script>
import Comments from '@/orm/models/Comments';

export default {
  name: 'dashboardCommentsBadge',
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    commentState: Object,
  },
  inject: ['showCommentAside'],
  computed: {
    countOfComment() {
      return Comments
        .query()
        .where('unique_id', this.commentState.uniqueId)
        .get()
        .length;
    },
  },
};
</script>
